/**
 * CountUp — números que CONTAM até o valor na entrada (0 → 24.512),
 * com easing suave e tabular-nums. Respeita prefers-reduced-motion.
 */
import { useEffect, useRef, useState } from 'react';

export function CountUp({
  value,
  locale = 'pt-BR',
  duration = 900,
}: {
  value: number;
  locale?: string;
  duration?: number;
}) {
  const [shown, setShown] = useState(0);
  const raf = useRef(0);

  useEffect(() => {
    if (typeof matchMedia !== 'undefined' && matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setShown(value);
      return;
    }
    const start = performance.now();
    const from = 0;
    const tick = (now: number) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      setShown(Math.round(from + (value - from) * eased));
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [value, duration]);

  return <span className="tabular-nums">{shown.toLocaleString(locale)}</span>;
}
